import { render, staticRenderFns } from "./DependencySync.vue?vue&type=template&id=9c22fb62"
import script from "./DependencySync.vue?vue&type=script&lang=js"
export * from "./DependencySync.vue?vue&type=script&lang=js"
import style0 from "./DependencySync.vue?vue&type=style&index=0&id=9c22fb62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports